export default __webpack_public_path__ + "static/media/logo.e18e1987.svg";